import React from 'react';

import { ColumnDef } from '@tanstack/react-table';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Button } from '@/components/ui/button';
import { BookOpen, Loader2, RotateCcw } from 'lucide-react';
import { Badge } from "@/components/ui/badge";

import { useNavigate } from 'react-router-dom';

interface DataTableProps<TData, TValue> {
  columns: ColumnDef<TData, TValue>[];
  data: TData[];
  onActions?: void;
}

export type AssignedQuizzes = {
  id: string;
  name: string;
  status: "Not Completed" | "Completed";
  progress: number;
}


export const getColumns = (onActions: DataTableProps<any, any>["onActions"]) => [
  // {
  //   id: 'id',                     // <-- REQUIRED with non-string header
  //   accessorKey: 'id',
  //   header: () => <span>ID</span>,
  // },
  {
    header: () => "Name",
    accessorKey: "name"
  },
  {
    header: () => "Status",
    accessorKey: "status",
    cell: ({ row }) => {
      if (row.original.status === "Completed") {
        return <Badge variant={'success'}>Completed</Badge>
      } else {
        return <Badge variant={'warning'}>Not Completed</Badge>
      }
    },
  },
  // {
  //   header: () => "Progress",
  //   accessorKey: "progress"
  // },
  {
    id: "actions",
    header: () => "Actions",
    cell: ({ row }) => {
      const navigate = useNavigate();

      return (
        <div className="flex gap-1 justify-center">
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => {
                    navigate(`/policy-reader/${row.original.id}`);
                  }}
                >
                  <BookOpen className="h-4 w-4" />
                </Button>
              </TooltipTrigger>
              {/*<TooltipContent>*/}
              {/*  <p>Read Policy</p>*/}
              {/*</TooltipContent>*/}
            </Tooltip>
          </TooltipProvider>
        </div>
      );
    },
  }
];
